import React from 'react';
import styled from 'styled-components';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

import InfoIcon from '~/components/Assets/info.svg';

const Label = styled.div`
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
`;

const LabelBottom = styled(Label)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
`;

const LabelTop = styled(Label)`
  top: 0;
  left: 0;
`;

const InfoButton = styled(InfoIcon)`
  width: 14px;
  height: 14px;
  cursor: default;
  margin-left: 4px;

  circle {
    stroke-width: 1 !important;
  }

  &:hover {
    opacity: 0.8;
  }
`;

const TooltipDiv = styled.div`
  // max-width: 150px;
`;

const Info = ({ text, tooltipMaxWidth = 200 }) => (
  <Tooltip
    placement="top"
    overlay={
      <TooltipDiv style={{ maxWidth: tooltipMaxWidth }}>{text}</TooltipDiv>
    }
  >
    <InfoButton />
  </Tooltip>
);

const AxisLabels = ({ margin }) => {
  return (
    <>
      <LabelTop>
        mittlerer Bruttolohn in Euro
        <Info
          tooltipMaxWidth={250}
          text="mittlerer Bruttolohn in Euro pro Monat für eine Vollzeitstelle. (ab 6.450 Euro ist der genaue Lohn nicht bekannt, weil der Lohn nur bis zur Beitragsbemessungsgrenze gemeldet wird)"
        />
      </LabelTop>
      <LabelBottom style={{ marginLeft: margin.left / 2 }}>
        Beschäftigungschancen
        <Info text="Arbeitslose je 100 offene Stellen" />
      </LabelBottom>
    </>
  );
};

export default AxisLabels;
